import sliceCreator from '../../index.jsx';
import {GET_ALL_VARIETIES} from '../../../constants/index.jsx';
const _getAllVarietiesAction = sliceCreator('GET_ALL_VARIETIES', GET_ALL_VARIETIES, 'get');

const { asyncAction: getAllVarietiesAction, reducer, clearData: clearGetAllVarietiesAction } = _getAllVarietiesAction;

export default reducer;

export {
    getAllVarietiesAction,
    clearGetAllVarietiesAction
}